<template>
  <div class="disease">
    <tabs @updateList="handleGetList"></tabs>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" class="cons-div">
      <div class="item-div" v-for="(item, index) in list" :key="index" @click="handleClick(item)">
        <items :dataProps="item"></items>
      </div>
    </van-list>
    <van-dialog v-model="show" title="积分解锁" :show-confirm-button="false">
      <!-- <div class="di_content">您已获得博观约取勋章，默认使用了勋章权益兑换。</div> -->
      <div class="di_content">您将消耗{{unlockCost}}积分兑换此等级心电图，是否确认兑换?</div>
      <div class="di_btn_group">
        <div class="di_btn cancel" @click.stop="() => (show = false)">取消</div>
        <div class="di_btn ok" @click.stop="handleClickOk">确认</div>
      </div>
    </van-dialog>
    <div class="fail_modal" v-if="showChange">
      <img class="img" :src="changeStatus ? ChangeOk : changeFail" alt="" />
      <p class="msg">{{ changeStatus ? "兑换成功" : "兑换失败" }}</p>
      <p class="tips">{{ exchangeTxt }}</p>
    </div>
  </div>
</template>
<script>
import items from './components/items.vue'
import tabs from './components/tabs.vue'
import { getBankList } from '../../api/questionBank'
import { getShareInfo } from '@/utils/wxShare'
import ChangeOk from '../../assets/train/change_ok.png'
import changeFail from '../../assets/train/change_fail.png'
import { unlockTraining } from '@/api/training'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  components: {
    items,
    tabs
  },
  data () {
    return {
      list: [],
      loading: false,
      finished: false,
      pageNo: 1,
      pageSize: 15,
      classCode: '',
      difficultyLevel: '',
      load: false,
      ChangeOk,
      changeFail,
      show: false,
      showChange: false,
      changeStatus: false,
      exchangeTxt: '',
      baseId: '',
      unlockCost: 0
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  mounted () {
    getShareInfo({
      title: 'iEP-心电图分类题库',
      titleTimeLine: 'iEP-海量心电图分类题库，进阶心电王者',
      desc: '解锁更多题目，进阶心电王者',
      link: window.location.href,
      linkTimeLine: window.location.href,
      images: `https://iep.jjmc.cn/bw/file/material/image/1933146816339349528.jpg`,
    })
  },
  methods: {
    handleClickOk() {
      this.show = false
      this.showChange = true
      let params = {
        openId: this.userInfo.iepOpenId,
        userId: this.userInfo.id,
        type: 3,
        unlockMethod: 1,
        unlockCost: this.unlockCost,
        unlockContent: `兑换心电图答题`,
        questionClass: this.questionClass,
        difficultyLevel: this.difficultyLevel
      }
      unlockTraining(params).then(res => {
        this.exchangeTxt = res.msg
        this.changeStatus = true
        setTimeout(() => {
          this.showChange = false
          this.handleGotoDetails()
        }, 1000)
      }).catch((err) => {
        this.changeStatus = false
        this.exchangeTxt = err.msg
        setTimeout(() => {
          this.showChange = false
        }, 1000)
      })
    },
    handleClick (item) {
      this.questionClass = item.classCode
      this.questionClassName = item.className
      this.difficultyLevel = item.difficultyLevel
      if (`${item.unlockStatus}` === '2' && `${item.unlockMethod}` === '1') {
        this.unlockCost = item.unlockCost
        this.show = true
        return
      } else if (`${item.unlockStatus}` === '2') {
        this.$toast({
          type: 'html',
          message: `<div>不积跬步无以至千里，请先完成${item.className}题库Level${item.difficultyLevel - 1}的测试，再来挑战Level${item.difficultyLevel}吧！</div>`,
          className: 'custom-toast'
        })
        return
      }
      this.handleGotoDetails()
    },
    handleGotoDetails() {
      this.$router.push({
        path: 'subject',
        query: {
          classCode: this.questionClass,
          className: this.questionClassName,
          difficultyLevel: this.difficultyLevel
        }
      })
    },
    handleGetList (e) {
      this.difficultyLevel = e.curLevel
      this.classCode = e.curEffec
      this.list = []
      this.loading = false
      this.finished = false
      this.pageNo = 1
      this.onLoad()
    },
    onLoad () {
      if (this.load) {
        return
      }
      this.load = true
      this.$toast.loading({ message: '加载中...' })
      let params = {
        pageNum: this.pageNo,
        pageSize: this.pageSize,
        classCode: this.classCode,
        difficultyLevel: this.difficultyLevel,
      }
      getBankList(params)
        .then(res => {
          this.load = false
          this.$toast.clear()
          if (res) {
            if (res.code !== 0 || !res.data || !res.data.list) {
              this.loading = false
              this.finished = true
              return false
            }
            res.data.list = res.data.list.map(item => {
              item.type = 'bank'
              if (item.answerTime) {
                item.answerTime = this.$moment(item.answerTime * 1).format('YYYY年MM月DD日')
              }
              return item
            })
            if (res.data.list.length < this.pageSize) {
              this.finished = true
            }
            if (res.code === 0 && res.data.list) {
              this.list = this.list.concat(res.data.list)
            }
            this.pageNo++
            if (this.list.length === 0) {
              this.isNone = true
            }
            this.loading = false
          }
        })
        .catch(err => {
          this.$toast.clear()
          console.log('err:', err)
        })
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.disease {
  min-height: 100vh;
  background-color: #F7F9FB;

  .cons-div {
    box-sizing: border-box;
    padding: 8px 15px;
    display: flex;
    flex-wrap: wrap;

    .item-div {
      width: 111px;
      background-color: #Fff;
      margin-bottom: 8px;
      position: relative;
      padding: 0 8px 4px;
      height: 170px;
      border-radius: 10px;
      box-sizing: border-box;

      &:nth-child(3n-1) {
        margin: 0 6px;
        margin-bottom: 8px;
      }
    }
  }
}

/deep/ .van-list__finished-text {
  width: 100%;
  display: block;
}

/deep/ .van-list__loading {
  width: 100%;
}

.van-dialog {
  width: 320px;
  height: 195px;
  background: #fff;
  /deep/.van-dialog__header {
    font-family: Source Han Sans CN, Source Han Sans CN;
    color: #000000;
    font-weight: 600;
    font-size: 17px;
    padding-top: 15px;
    line-height: 24px;
  }
}
.di_content {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.8);
  padding: 28px 26px;
  box-sizing: border-box;
  line-height: 21px;
}
.di_btn_group {
  display: flex;
  padding: 0 17px;
  box-sizing: border-box;
  justify-content: space-between;
  .di_btn {
    width: 130px;
    height: 42px;
    line-height: 42px;
    text-align: center;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    border-radius: 30px;
  }
  .ok {
    background: #EB1700;
    box-shadow: 0px 2px 4px 0px rgba(255, 91, 12, 0.25);
    color: #fff;
  }
  .cancel {
    background: rgba(0, 0, 0, 0.08);
    color: #7a8494;
  }
}
.fail_modal {
  width: 200px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 19px 19px 19px 19px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 24px;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 9;

  .img {
    width: 42px;
    width: 42px;
    margin-bottom: 15px;
  }
  .msg {
    width: 100%;
    text-align: center;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 600;
    font-size: 17px;
    line-height: 20px;
    color: #ffffff;
    margin-bottom: 4px;
  }
  .tips {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    line-height: 20px;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
  }
}
</style>

<style>
.custom-toast {
  padding: 30px 20px !important;
  min-width: 200px !important;
  text-align: left !important;
}
</style>



// WEBPACK FOOTER //
// src/views/questionBank/disease.vue